module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "warn_alert"
    }
  }, [_c('div', {
    staticClass: "pool"
  }), _vm._v(" "), _c('div', {
    staticClass: "warn_box"
  }, [_c('div', {
    staticClass: "warn"
  }, [_vm._v("服务异常，请稍后再试")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2706d1c8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/warn.vue
// module id = 233
// module chunks = 81